<template>
  <div id="app">
    <ClickEffect />
    <router-view/>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import ClickEffect from './components/ClickEffect.vue'

export default defineComponent({
  name: 'App',
  components: {
    ClickEffect
  }
})
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}

#particles-container {
  pointer-events: none !important;
}
</style>
